import { GLBModel } from "@/scene/GLBModel";
import type { EnvironmentDecorItemConfig } from "@/scene/SceneProps";
import type { UnderwaterVisualSettingsOverride } from "@/scene/VisualSettings";
import {
  ASSORTED_ROCK_MODELS,
  CORAL_MODELS,
  LOG_MODEL,
  ROCK_FORMAT2_MODEL,
  ROCK_MODEL,
} from "./shared";

// Иния — Бытовая химия: шампунь, стиральный порошок, средство для посуды, тара
export const INIYA_GARBAGE_MODELS = [
  new GLBModel("/models/garbage/shampu.glb"),
  new GLBModel("/models/garbage/02_powder.glb"),
  new GLBModel("/models/garbage/02_big_bottle.glb"),
  new GLBModel("/models/garbage/bottle_02.glb"),
];

export const INIYA_ENVIRONMENT_DECOR: EnvironmentDecorItemConfig[] = [
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 0.78,
    position: { x: -1.65, y: -2.28, z: -1.15 },
    rotation: { x: 0, y: 0.42, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: ROCK_MODEL,
    targetSize: 0.58,
    position: { x: 1.65, y: -2.28, z: -0.9 },
    rotation: { x: 0, y: -0.7, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 0.52,
    position: { x: 0.88, y: -2.29, z: 1.18 },
    rotation: { x: 0, y: 2.35, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: ROCK_MODEL,
    targetSize: 0.44,
    position: { x: -1.05, y: -2.3, z: 1.02 },
    rotation: { x: 0, y: 1.65, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: LOG_MODEL,
    targetSize: 1.35,
    position: { x: -0.18, y: -2.28, z: 1.62 },
    rotation: { x: 0.04, y: -0.78, z: 0.06 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: LOG_MODEL,
    targetSize: 2,
    position: { x: 0.04, y: -3.05, z: -4.9 },
    rotation: { x: 0.104, y: 0.292, z: 0.574 },
    scale: { x: 3.8, y: 5.7, z: 1 },
  },
  {
    model: LOG_MODEL,
    targetSize: 2,
    position: { x: 0.18, y: -2.28, z: 3 },
    rotation: { x: 0, y: -0.524, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: LOG_MODEL,
    targetSize: 2,
    position: { x: 3, y: -2, z: 0.36 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 1.07,
    position: { x: 2, y: -2.27, z: 2 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 0.7,
    position: { x: -1.6, y: -2.85, z: -3.3 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 3.25, y: 4.65, z: 1.65 },
  },
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 0.7,
    position: { x: -3.95, y: -2.85, z: -1.35 },
    rotation: { x: 0, y: -0.785, z: 0 },
    scale: { x: 3.25, y: 3.15, z: 3.25 },
  },
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 0.7,
    position: { x: -2.65, y: -2.45, z: -2.7 },
    rotation: { x: 0, y: -1.571, z: 0 },
    scale: { x: 1.65, y: 2.05, z: 1.8 },
  },
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 0.7,
    position: { x: -1.6, y: -3.1, z: -2.25 },
    rotation: { x: 0, y: -1.571, z: 0 },
    scale: { x: 1.65, y: 2.05, z: 1.8 },
  },
  {
    model: ROCK_MODEL,
    targetSize: 0.7,
    position: { x: 2.1, y: -2.7, z: -5.8 },
    rotation: { x: 0, y: -0.785, z: 0 },
    scale: { x: 4.15, y: 4.85, z: 2.95 },
  },
  {
    model: ROCK_MODEL,
    targetSize: 0.7,
    position: { x: 4.05, y: -3.05, z: -3.2 },
    rotation: { x: 3.142, y: -1.397, z: 3.142 },
    scale: { x: 4.15, y: 4.85, z: 2.95 },
  },
  {
    model: ROCK_MODEL,
    targetSize: 0.7,
    position: { x: 1.85, y: -3.05, z: -3.02 },
    rotation: { x: 3.142, y: -1.397, z: 3.142 },
    scale: { x: 2.2, y: 3.25, z: 1.25 },
  },
  {
    model: ASSORTED_ROCK_MODELS[27],
    targetSize: 0.7,
    position: { x: -0.25, y: -2.7, z: -3.2 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1.6, y: 2.7, z: 1 },
  },
  {
    model: CORAL_MODELS[5],
    targetSize: 0.7,
    position: { x: -2.05, y: -2.6, z: -2.55 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1.6, y: 2.15, z: 1.45 },
  },
  {
    model: CORAL_MODELS[5],
    targetSize: 0.7,
    position: { x: 1.45, y: -2.9, z: -4.75 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1.3, y: 3, z: 1.6 },
  },
  {
    model: CORAL_MODELS[5],
    targetSize: 0.7,
    position: { x: 2.93, y: -2.6, z: -1.97 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1.6, y: 3.6, z: 2 },
  },
];

export const INIYA_VISUAL_SETTINGS: UnderwaterVisualSettingsOverride = {
  toneExposure: 1.02,
  environmentIntensity: 0.92,
  ambientIntensity: 0.71,
  ambientColor: "#bffaff",
  hemisphereIntensity: 1.29,
  hemisphereSkyColor: "#65e9ff",
  hemisphereGroundColor: "#075c7a",
  keyIntensity: 2.03,
  keyColor: "#fff4d7",
  fillIntensity: 1.72,
  fillColor: "#20dfff",
  rimIntensity: 1.07,
  rimColor: "#b6fdff",
  shimmerIntensity: 1.08,
  shimmerColor: "#29eaff",
  cameraFillIntensity: 1.42,
  cameraFillColor: "#c8fbff",
  causticsOpacity: 0.59,
  causticsScale: 0.73,
  causticsSpeed: 0.35,
  causticsIntensity: 0.75,
  causticsDeepColor: "#04506f",
  causticsShallowColor: "#12bad2",
  causticsHighlightColor: "#b8fff0",
  causticsSurfaceGlowColor: "#039fbd",
  causticsRadiusScale: 1.59,
  surfaceGlowIntensity: 0,
  lightRaysOpacity: 0.24,
  lightRaysColor: "#c8ffff",
  lightRaysWidth: 1.35,
  lightRaysLength: 1,
  lightRaysVerticalOffset: 0.5,
  lightRaysSpeed: 1.95,
  lightRaysCount: 30,
  bubbleCount: 120,
  bubbleSize: 1,
  bubbleOpacity: 0.19,
  bubbleSpeed: 0.07,
  bubbleDrift: 0.78,
  bubbleSpread: 0.91,
  particleCount: 1200,
  particleSize: 2.66,
  particleOpacity: 0.86,
  particleSpeed: 0.16,
  particleDrift: 1,
  particleSpread: 1.25,
  depthFogDensity: 0.057,
  waterGradientOpacity: 0.44,
  waterGradientTopIntensity: 1.28,
  waterGradientBottomIntensity: 1,
  waterGradientHeight: -2.3,
  waterSurfaceColor: "#69e7ff",
  pollutionColor: "#29929c",
  waterSurfaceOpacity: 0.78,
  waterSurfaceHeight: 6.4,
  waterSurfaceWaveStrength: 0.18,
  waterSurfaceWaveScale: 1.36,
  waterSurfaceWaveSpeed: 0.78,
  floorOpacity: 0.92,
  seabedRadius: 1.71,
  seabedDepth: 0,
  seabedMurkiness: 0.76,
  seabedTextureScale: 1.65,
  seabedCaustics: 0.46,
  seabedRelief: 1.45,
  seaweedCount: 80,
  seaweedArea: 2.01,
  seaweedColor: "#07b687",
  seaweedTipColor: "#28d283",
  seaweedHeight: 0.72,
  seaweedWidth: 1.64,
  seaweedSway: 25.73,
  seaweedTipLight: 1.12,
  seaweedDepthFade: 0.52,
};
